import gql from 'graphql-tag'
import {teacherFragment} from '../fragments'

export const CreateClassroom = gql`
mutation CreateClassroom($grade: Int, $name: String, $managerId: ID, $teachers: [Int]) {
  createClassroom(grade: $grade, name: $name, managerId: $managerId, teachers: $teachers) {
    classroom {
      id
      name
      grade
      teachers {
        ...teacherFragment
      }
    }
  }
}
${teacherFragment}
`




export const UpdateClassroom = gql`
mutation UpdateClassroom($id: ID!, $grade: Int, $name: String, $managerId: ID, $teachers: [Int]) {
  updateClassroom(id: $id,grade: $grade, name: $name, managerId: $managerId, teachers: $teachers) {
    classroom {
      id
      name
      grade
      teachers {
        ...teacherFragment
      }
    }
  }
}
${teacherFragment}
`


export const DeleteClassroom = gql`
mutation DeleteClassroom($id: ID!) {
  deleteClassroom(id: $id) {
    id_
  }
}
`
